import React from 'react';
import API from 'utils/API';
import play from './images/google_play.png';
import './style.scss';

const ModalAndroid = () => {
    return (
        <div className="android-links-modal">
            <a
                className="google-play"
                href={`${API.CUSTOMER.appLink() }?platform=android&app_name=TradeUP&lang=en_US`}
                target="view_window">
                <img src={play} className="img-responsive" alt="googlePlay" />
            </a>
            <hr />
            <a className="apk" download href={API.STATIC.apk()} target="view_window">
                Dowload APK (for advanced users)
            </a>
        </div>
    );
};

export default ModalAndroid;
